import I18N from "oc-I18N";

/**
 * Die allgemeine Schnittstelle, die von allen Dialogsystem-Implementierungen (Jquery, Bootstrap, ...)
 * implementiert werden muss, und von holodeck Komponenten überall benutzt werden kann, ohne sich
 * an eine Implementierung zu binden.
 * Generell sollte message / label ein String sein, in dem HTML-Tags stehen dürfen.
 */
const Dialogs = {};

Dialogs.showToast = (message, duration) => {
    alert(message);
    return {hide: () => {}};
};

Dialogs.showWarning = (message) => {
    alert(message);
    return {hide: () => {}};
}

Dialogs.showError = (message) => {
    alert(message);
};

Dialogs.showWaiting = (message) => {
    alert(message);
    return {hide: () => {}};
};

// buttonAndActionList ist eine Liste von {label: string, primary: boolean, action: callback }
Dialogs.askQuestion = (message, buttonAndActionList) => {
    alert(message);
    return {hide: () => {}};
};

Dialogs.askQuestionOkOrCancel = (message, okLabel = I18N('OK'), okFun = ()=>{}, cancelFun = ()=>{}) => {
    Dialogs.askQuestion(message, [
        {label: okLabel, primary: true, action: okFun},
        {label: I18N('Abbrechen'),  action: cancelFun},
    ]);
};

Dialogs.showOk = (message, okFun = ()=>{}) => {
    Dialogs.askQuestion(message, [
        {label: I18N('OK'), primary: true, action: okFun},
    ]);
};

Dialogs.showHtml = (htmlElement) => {
    alert(htmlElement);
    return {hide: () => {}};
};

export default Dialogs;